import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Popconfirm } from 'antd';
import { Button, Table } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { imgSrcParser } from 'utils/imgSrcParser';
import { SocialNetwork } from 'types/SocialNetwork';
import SocialNetworkDrawer from './SocialNetworkDrawer';
import { StyledSocialNetworksTab } from './style';

const SocialNetworksTab = () => {
  const intl = useIntl();
  const [reload, setReload] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editing, setEditing] = useState<SocialNetwork>();

  const refresh = () => setReload((value) => value + 1);

  const { appendData: deleteSocialNetwork } = useQueryApiClient({
    request: {
      url: 'api/v2/social-networks/:id',
      method: 'DELETE',
    },
    onSuccess: refresh,
  });

  const openDrawer = (socialNetwork?: SocialNetwork) => {
    setEditing(socialNetwork);
    setIsDrawerOpen(true);
  };

  const columns = [
    {
      title: intl.formatMessage({ id: 'general.logo' }),
      dataIndex: 'logo',
      render: (logo: string | null, record: SocialNetwork) =>
        logo ? (
          <img
            className={'social-network-logo'}
            src={imgSrcParser(logo)}
            alt={record.name}
          />
        ) : null,
    },
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'name',
    },
    {
      title: intl.formatMessage({ id: 'general.actions' }),
      render: (record: SocialNetwork) => (
        <div className={'social-network-actions'}>
          <Button
            type={'primary'}
            label={intl.formatMessage({ id: 'general.edit' })}
            onClick={() => openDrawer(record)}
          />
          {!record.code && (
            <Popconfirm
              title={intl.formatMessage({
                id: 'social_networks.delete_confirm',
              })}
              okText={intl.formatMessage({ id: 'general.delete' })}
              cancelText={intl.formatMessage({ id: 'general.cancel' })}
              onConfirm={() => deleteSocialNetwork([], { id: record.id })}
            >
              <Button label={intl.formatMessage({ id: 'general.delete' })} />
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  return (
    <StyledSocialNetworksTab>
      <Button
        type={'primary'}
        className={'social-network-add'}
        label={intl.formatMessage({ id: 'social_networks.add' })}
        onClick={() => openDrawer()}
      />
      <Table
        columns={columns}
        url={'/api/v2/social-networks'}
        reload={reload}
        disablePagination
        rowKey={'id'}
      />
      <SocialNetworkDrawer
        open={isDrawerOpen}
        socialNetwork={editing}
        onClose={() => setIsDrawerOpen(false)}
        onSaved={refresh}
      />
    </StyledSocialNetworksTab>
  );
};

export default SocialNetworksTab;
